import React from "react";
import { ArrowRight, Smartphone, Gauge, Pencil } from "lucide-react";
import { BrowserFrame, PhoneFrame } from "./Frames";
import { MEDIA } from "../mock";
import { Script } from "./Script";

const POINTS = [
  { icon: Gauge, title: "Načtení pod 1 sekundu", desc: "Rychlost, kterou ocení Google i zákazník." },
  { icon: Smartphone, title: "Perfektní na mobilu", desc: "Dvě třetiny návštěv přijdou z telefonu." },
  { icon: Pencil, title: "Obsah si upravíte sami", desc: "Jednoduchá administrace bez kódu." },
];

export default function LimeShowcase() {
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="lime" className="relative bg-[#d8ff00] pt-24 md:pt-32 overflow-hidden" data-testid="lime-showcase">
      <div className="absolute inset-x-0 bottom-0 h-[38%] bg-gradient-to-b from-transparent to-white pointer-events-none" />

      <div className="container-x relative">
        <h2 className="reveal display text-[#0e0e0d] text-center text-[10vw] sm:text-6xl lg:text-7xl">
          Vypadejte{" "}
          <Script color="#0e0e0d" className="text-[11vw] sm:text-7xl lg:text-8xl mx-2">
            skvěle.
          </Script>
          <br />
          Vydělávejte víc.
        </h2>

        <p className="reveal mt-12 text-center text-[#0e0e0d]/70 text-base md:text-lg max-w-2xl mx-auto">
          Design, vývoj, texty i technika pod jednou střechou. Vy řešíte podnikání, my web.
        </p>

        <div className="mt-16 md:mt-20 grid lg:grid-cols-12 gap-10 lg:gap-6 items-center pb-24 md:pb-32">
          <div className="reveal lg:col-span-3">
            <p className="eyebrow text-[#0e0e0d]/50">Nový standard</p>
            <h3 className="text-2xl md:text-3xl display text-[#0e0e0d] mt-3">Web, který dělá práci za vás</h3>
            <p className="text-[#0e0e0d]/70 mt-4 text-sm md:text-base leading-relaxed">
              Od prvního dojmu po odeslanou poptávku. Každá sekce má svůj úkol a každý pixel svůj důvod.
            </p>
            <button
              onClick={() => go("#sluzby")}
              data-testid="lime-services-link"
              className="underline-link mt-6 inline-flex items-center gap-2 text-[#0e0e0d]"
            >
              Co všechno umíme <ArrowRight size={16} />
            </button>
          </div>

          <div className="reveal lg:col-span-6 relative">
            <div className="relative" style={{ perspective: "1400px" }}>
              <BrowserFrame
                media={MEDIA.siteDesktop}
                host={MEDIA.siteHost}
                className="rotate-[-1.4deg]"
                mediaClass="aspect-[16/9] object-cover"
              />
              <PhoneFrame
                media={MEDIA.siteMobile}
                className="absolute -bottom-12 -right-4 sm:-right-10 w-[34%] max-w-[180px] rotate-[6deg]"
              />
            </div>
          </div>

          <div className="reveal lg:col-span-3 space-y-7 lg:pl-6">
            {POINTS.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="flex gap-4">
                <span className="grid place-items-center w-10 h-10 rounded-full bg-[#0e0e0d] text-[#d8ff00] shrink-0">
                  <Icon size={17} />
                </span>
                <div>
                  <p className="font-semibold text-[#0e0e0d]">{title}</p>
                  <p className="text-sm text-[#0e0e0d]/65 mt-1">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
